/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TermUseAliases {
  CHECKBOX_AGREE = 'checkbox-agree',
  FETCH_TERM_USE = 'fetch-term-use',
  FIELD_AGREE = 'field-agree',
  FORM_TERM_USE = 'form-term-use',
  HTML_VIEWER_TERM_USE = 'html-viewer-term-use',
  MODAL_TERM_USE = 'modal-term-use',
}
export { TermUseAliases };
